export default {

    libyanNationality: 1,
}